import { IP_CITY_FETCH_ROUTE, IP_CITY_KEY } from "@constants/leadCapture";

/**
 * Get city information from IP address with caching
 */
export async function getCityFromIp() {
  const cachedCity = sessionStorage.getItem(IP_CITY_KEY);
  if (cachedCity) {
    console.log(`[IP CITY] [CACHE HIT] ${cachedCity}`);
    return cachedCity;
  }

  let ip_city = null;
  try {
    const res = await fetch(IP_CITY_FETCH_ROUTE);
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    ip_city = data.ip_city;

    if (ip_city) {
      sessionStorage.setItem(IP_CITY_KEY, ip_city);
    }
  } catch (error) {
    console.error(`[GET IP CITY API] [FAILURE] error: ${error}`);
  }

  return ip_city;
} 